import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TableCellComponent } from '../../table/table.model';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-action-cell',
	templateUrl: './action-cell.component.html',
	styleUrls: ['./action-cell.component.scss'],
	imports: [IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionCellComponent implements TableCellComponent<ActionCellProperties | undefined> {
	data!: ActionCellProperties | undefined;
}

export interface ActionCellProperties {
	title?: string;
	icon?: IconName;
	callback: () => void;
}
